import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container-btn" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "btn-icon"
}
const _hoisted_4 = {
  key: 1,
  class: "btn-title"
}
const _hoisted_5 = {
  key: 2,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      disabled: _ctx.disabled || _ctx.loading,
      class: _normalizeClass(_ctx.classes),
      ontouchstart: "",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickBtn && _ctx.clickBtn(...args)))
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              size: "lg",
              icon: _ctx.icon
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.title && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t(_ctx.title)), 1))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
          : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ]))
}